import React from 'react';

import ValidationAlert from '@/components/common/ValidationAlert/ValidationAlert';
import styles from './error-tooltip.module.scss';

interface IErrorTooltipProps {
  title?: string;
  errors: string[];
}

export default function ErrorTooltip({ title, errors }: IErrorTooltipProps) {
  return (
    <div className={styles['error-tooltip']}>
      <ValidationAlert>
        {title && (
          <div className={styles.title}>
            <b>{title}:</b>
          </div>
        )}

        {errors.map((err, i) => (
          <div key={i}>- {err}</div>
        ))}
      </ValidationAlert>
    </div>
  );
}
